(function () {
  const STORAGE_KEY = "skims:july-sale-access";
  const PARAM_NAME = "july_sale";

  try {
    const url = new URL(window.location.href);
    const param = url.searchParams.get(PARAM_NAME);

    if (param === "1" || param === "true") {
      sessionStorage.setItem(STORAGE_KEY, "1");
    }

    if (sessionStorage.getItem(STORAGE_KEY) !== "1") return;

    document.querySelectorAll("[data-july-sale-pre-sale]").forEach((el) => {
      el.hidden = false;
    });
  } catch (_error) {
    // sessionStorage unavailable
  }
})();
